import React from "react";
import { motion } from "framer-motion";
const TOTAL_SPOTS = 100;
const SPOTS_LEFT = 7;
export function ScarcityBar() {
  const claimed = TOTAL_SPOTS - SPOTS_LEFT;
  return <div className="mt-8 rounded-2xl border border-petal bg-blush/60 p-4" data-id="element-52" data-mp="2l4xs2rydc4kp">
      <div className="flex items-center justify-between gap-3 text-[14px]" data-id="element-53" data-mp="2l2tpcdc7hbm0">
        <p className="flex items-center gap-2 font-bold text-ink" data-id="element-54" data-mp="2q2g3cozuyvvv">
          <span className="relative flex h-2.5 w-2.5" data-id="element-55" data-mp="2b6gydn81pbuy">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-berry opacity-60" data-id="element-56" data-mp="2b8uorirs5zw6" />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-berry" data-id="element-57" data-mp="2261ztm62m09i" />
          </span>
          Only {SPOTS_LEFT} spots left at $27
        </p>
        <span className="font-semibold text-berry" data-id="element-58" data-mp="275onkpjiyywk">{claimed}% claimed</span>
      </div>
      <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-white" role="progressbar" aria-valuenow={claimed} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-59" data-mp="g0b5weqislg">
        <motion.div className="h-full rounded-full bg-berry" initial={{
        width: "60%"
      }} whileInView={{
        width: `${claimed}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.9,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-60" data-mp="2zl9modftduli" />
      </div>
      <p className="mt-2 text-[13px] text-muted" data-id="element-61" data-mp="38fo9r26l69f6">
        When the remaining {SPOTS_LEFT} spots are gone, the promotional price ends.
      </p>
    </div>;
}